import { Box, Stack, Typography } from '@mui/material'

// Rodapé do console -- crédito da softhouse (SMS Murilo) em todas as páginas autenticadas.
// A logo é PNG com fundo transparente (public/sms-murilo-logo.png), legível no claro e no
// escuro (o texto "MURILO" tem contorno branco).
export function AppFooter() {
  return (
    <Box component="footer" sx={{ borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper', px: { xs: 2, sm: 3 }, py: 2.5 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems="center"
        justifyContent="center"
        sx={{ maxWidth: 1500, mx: 'auto' }}
      >
        <Box
          component="img"
          src="/sms-murilo-logo.png"
          alt="SMS Murilo — Softwares Inteligentes"
          sx={{ height: 30, width: 'auto', flexShrink: 0 }}
        />
        <Typography variant="caption" color="text.secondary" textAlign="center">
          © 2026 Órbita · Todos os direitos reservados a SMS Murilo — Softwares Inteligentes.
        </Typography>
      </Stack>
    </Box>
  )
}
